import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import CategoryManager from './CategoryManager';
import randomInt from "../utils/randomInt";

class TimelessStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  fetching = false;

  find(id) {
    return this.getState().find(category => {
      return category.id === parseInt(id, 10);
    });
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.CATEGORY_STORE_FETCH:
        CategoryManager.fetch();
        return state;

      case ActionTypes.CATEGORY_STORE_FETCH_COMPLETE:
        // return sort(action.categories);
        return action.categories;

      default:
        return state;
    }
  }

  getRandomCover(category) {
    if(category['covers'].length===1)
      return category['covers'][0]['cover'];

    return category['covers'][randomInt(0, category.covers.length-1)]['cover'];
  }


}

/**
 *
 * @param collections
 * @returns {Array}
 */
// function sort(collections) {
//   return collections.sort((collection1, collection2) => {
//     // noinspection JSUnresolvedVariable
//     return collection1.sorting < collection2.sorting;
//   });
// }

export default new TimelessStore();
